import { useEffect } from "react"
import { useLocation } from "react-router-dom"

declare global {
  interface Window {
    dataLayer: Record<string, any>[]
  }
}

export const useGoogleTagManager = () => {
  const location = useLocation()

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "page_view",
        page_path: location.pathname,
        page_location: window.location.href
      })
    }
  }, [location])
}

export const pushCustomTag = (tags: Record<string, any>) => {
  if (window.dataLayer) {
    window.dataLayer.push(tags)
  }
}
